import { DataProvider } from 'react-admin'
import { throwNotSupported } from '../../../dataProvider'
import { uncachedClient } from '../../../stackGqlClient'
import { gql } from '@apollo/client'

interface AffiliateNode {
  databaseId: string
  name: string
  company: string
  organization: { databaseId: string }
}

interface AffiliateResponse {
  id: string
  name: string
  company: string
  organization: { databaseId: string }
}

const affiliateProvider: DataProvider = {
  getList: async (_resource, { sort, pagination, filter }) => {
    const { field, order } = sort || {}
    const { page, perPage } = pagination || {}
    const { id, q } = filter || {}

    return uncachedClient
      .query({
        query: gql`
          query (
            $id: String
            $page: Int
            $perPage: Int
            $field: String
            $order: String
            $q: String
          ) {
            viewer {
              ... on OrgUser {
                affiliates(
                  id: $id
                  page: $page
                  perPage: $perPage
                  orderField: $field
                  orderDirection: $order
                  searchQuery: $q
                ) {
                  nodes {
                    databaseId
                    name
                    company
                    organization {
                      databaseId
                    }
                  }
                  pageInfo {
                    totalPages
                    totalCount
                  }
                }
              }
            }
          }
        `,
        variables: {
          page,
          perPage,
          field,
          order,
          id,
          q
        }
      })
      .then((result) => {
        const { totalCount } = result.data.viewer.affiliates.pageInfo
        const data = result.data.viewer.affiliates.nodes
          .map(parseAffiliate)
          .filter(Boolean)
        return {
          data,
          total: totalCount
        }
      })
  },
  getOne: throwNotSupported,
  getMany: throwNotSupported,
  getManyReference: throwNotSupported,
  update: throwNotSupported,
  updateMany: throwNotSupported,
  create: throwNotSupported,
  delete: throwNotSupported,
  deleteMany: throwNotSupported
}

const parseAffiliate = (affiliate: AffiliateNode): AffiliateResponse | null => {
  if (!affiliate) return null

  const { databaseId, ...rest } = affiliate

  return {
    id: databaseId,
    ...rest
  }
}

export default affiliateProvider
